import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import questionService from "../../services/questions.service";

function DeleteQuestion() {
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();

  const deleteOneRow = async (e, id) => {
    e.preventDefault();
    setLoading(true);
    const { data } = await questionService.deleteOne(id);
    if (data) {
      setError(false);
      navigate("/questions/showquestions");
    } else {
      setError(true);
    }
    setLoading(false);
    // console.log("deleted");
  };
  return (
    <div className="container p-5 text-center">
      <h3 className="text-center">
        Are You Sure You Need To Delete This Question?
      </h3>
      <div className="d-flex justify-content-center">
        <button
          onClick={(e) => deleteOneRow(e, `${id}`)}
          className="btn btn-danger m-3"
        >
          {loading ? "Loading..." : "Delete"}
        </button>
        <button
          onClick={() => {
            navigate("/questions/showquestions");
          }}
          className="btn btn-info m-3"
        >
          Back
        </button>
      </div>
      <div className="text-center">
        {error ? <p className="fs-5 text-danger">something is wrong</p> : ""}
      </div>
      <div className="m-auto">
        <p className="text-success fs-5 w-50 m-auto">
          Note: If there are answers for this question, you cannot delete
        </p>
      </div>
    </div>
  );
}

export default DeleteQuestion;
